module.exports = { prefix: 'fas', iconName: 'mobile', icon: [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };


/*****************
 ** WEBPACK FOOTER
 ** ./~/@fortawesome/fontawesome-free-solid/faMobile.js
 ** module id = 262
 ** module chunks = 0
 **/